// src/pages/NotFoundPage.jsx
import { Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
    const navigate = useNavigate();
    return (
        <div style={{
            textAlign: 'center',
            marginTop: '8rem',
        }}>
            <Typography variant="h1" sx={{ fontSize: 120, fontWeight: 'bold', color: 'text.secondary' }}>
                404
            </Typography>
            <Typography variant="h5" sx={{ marginBottom: '1rem' }}>
                お探しのページは見つかりません
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: '2rem', color: 'text.secondary' }}>
                URLが間違っているか、アクセス権がないページです。
            </Typography>
            <Button variant="contained" color="primary" onClick={() => navigate('/')}>
                トップページに戻る
            </Button>
        </div>
    );
};

export default NotFoundPage;
